module.exports = __webpack_public_path__ + "img/sucrose.5359a789.webp";